// ** Router imports
import { lazy } from 'react'

// ** Router imports
import { useRoutes, Navigate, useLocation } from 'react-router-dom'

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'

// ** Hooks Imports
import { useLayout } from '@hooks/useLayout'

// ** Utils
import { getUserData, getHomeRouteForLoggedInUser, onSyncData } from '../utility/Utils'

// ** GetRoutes
import { getRoutes } from './routes'
import { onMessageListener } from '../firebase'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { syncData } from "@store/actions/data";

// ** Components
const Error = lazy(() => import('../views/Pages/misc/Error'))
const Login = lazy(() => import('../views/Pages/authentication/Login'))
const NotAuthorized = lazy(() => import('../views/Pages/misc/NotAuthorized'))
const Router = () => {
  // ** Hooks
  const dispatch=useDispatch()
  const { layout } = useLayout()
//   const location = useLocation();
//   console.log('locat',location);
//   onMessageListener().then(payload => {
    
//     if (location.pathname == '/Setup/Chat') {
//       return;
//     }else{
//       if (payload.data.Type == "0") {
//         dispatch(syncData('MemberOpendSeassions'))
//         toast.success("New Message Recived")
//       } else {
//         toast.success("New Session Opend")
//       }
//     } 
    
// }).catch(err => console.log('failed: ', err));

  const allRoutes = getRoutes(layout)
  const getHomeRoute = () => {
    const user = getUserData()
    if (user) {
      console.log('hacker_it', user.role);
      return getHomeRouteForLoggedInUser(user.role)
    } else {
      return '/login'
    }
  }

  const routes = useRoutes([
    {
      path: '/',
      index: true,
      element: <Navigate replace to={getHomeRoute()} />
    },
    {
      path: '/login',
      element: <BlankLayout />,
      children: [{ path: '/login', element: <Login /> }]
    },
    {
      path: '/auth/not-auth',
      element: <BlankLayout />,
      children: [{ path: '/auth/not-auth', element: <NotAuthorized /> }]
    },
    {
      path: '*',
      element: <BlankLayout />,
      children: [{ path: '*', element: <Error /> }]
    },
    ...allRoutes
  ])

  return routes
}

export default Router
